import { Colors } from '@/models/enums'

export const ICON_NAME_BY_COLOR = {
  [Colors.NEUTRAL]: 'information-outline',
  [Colors.PRIMARY]: 'sms',
  [Colors.SUCCESS]: 'check-circle',
  [Colors.WARNING]: 'warning',
  [Colors.DANGER]: 'error',
  error: 'error',
  danger: 'error',
}

export const ALLOWED_TYPES = [
  Colors.NEUTRAL,
  Colors.PRIMARY,
  Colors.SUCCESS,
  Colors.DANGER,
  Colors.WARNING,
  'danger',
  'error',
] as const

export type AllowedTypes = (typeof ALLOWED_TYPES)[number]
